<template>
  <div>
    <v-btn color="primary" text class="ma-2" @click.native.stop.prevent="toggleModal" id="missionDeletionModal">
      Delete
    </v-btn>
    <v-dialog v-model="isModalOpen" max-width="630px" persistent>
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Delete Quest</v-toolbar-title>
      </v-toolbar>
      <v-card class="modal-content-container">
        <v-card-title class="d-flex justify-center">
          <span class="body-heading-small ma-8">
            You're about to delete this quest.
          </span>
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="remove">
            <v-row class="px-3 justify-space-between">
              <v-btn color="secondary" class="modal-btn" type="submit">Delete </v-btn>
              <v-btn color="secondary" class="modal-btn" outlined @click="toggleModal">Cancel</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "DeleteMission",
    data() {
      return {
        isModalOpen: false,
      };
    },
    props: {
      missionId: {
        type: [String, Number],
        required: true,
      },
    },
    methods: {
      toggleModal() {
        this.isModalOpen = !this.isModalOpen;
      },

      remove() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .delete(`/missions/${this.missionId}`)
          .then((response) => this.removeSuccess(response))
          .catch((error) => this.removeFail(error));
      },

      removeSuccess(response) {
        this.$store.commit("setError", {
          message: "You have removed the quest.",
          type: "success",
        });

        this.$store.commit("removeMission", this.missionId);
        this.isModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
        if (this.$route.name !== "KidQuests") {
          this.$router.push({ name: "KidQuests" });
        }
      },

      removeFail(error) {
        console.log(error);
        this.$store.commit("setError", {
          message: this.$formatter.getErrorMsg(error),
          type: "error",
        });

        this.isModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Mission/DeleteMission.vue